// First, we must import the schema creator
import createSchema from 'part:@sanity/base/schema-creator'

// Then import schema types from any plugins that might expose them
import schemaTypes from 'all:part:@sanity/base/schema-type'

import work from './work.js'
import about from './about.js'
import homepage from './homepage.js'
import contact from './contact.js'
import news from './news.js'
import settings from './settings.js'
import workType from './workType.js'
import workLocation from './workLocation.js'
import workMedium from './workMedium.js'


// Then we give our schema to the builder and provide the result to Sanity
export default createSchema({
  // We name our schema
  name: 'default',
  // Then proceed to concatenate our document type
  // to the ones provided by any plugins that are installed
  types: schemaTypes.concat([
    homepage,
    work,
    about,
    contact,
    news,
    settings,
    workType,
    workLocation,
    workMedium
  ]),
})



// WEBPACK FOOTER //
// ./schemas/schema.js